module.exports = __webpack_public_path__ + "static/media/welcome-login.14988f53.svg";